import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAdmin, selectIsLoggedIn } from "../redux/authSlice";


const RequireAuth = ({ requireLogin, requireAdmin }) => {
    const location = useLocation();


    const isAdmin = useSelector(selectIsAdmin);
    const isLoggedIn = useSelector(selectIsLoggedIn);

    // let authorized;

    // if (requireAdmin) {
    //     authorized = isAdmin;
    // } else if (requireLogin) {
    //     authorized = isLoggedIn
    // } else {
    //     authorized = true;
    // }

    const authorized = (requireAdmin && isAdmin) || (requireLogin && isLoggedIn) || (!requireAdmin && !requireLogin);

    if (requireLogin && !isLoggedIn) {
        const redirectPath = `${location.pathname}${location.search}`; // Preserve params
        console.log(`setting sessionStorage redirectAfterAuth to ${redirectPath}`);
        sessionStorage.setItem("redirectAfterAuth", redirectPath);
    }

    return (
        authorized
            ?
            <Outlet />
            :
            isLoggedIn
                ?
                <Navigate to="/unauthorized" state={{ from: location }} replace />
                :
                <Navigate to="/login" state={{ from: location }} replace />
    );

}

export default RequireAuth;